import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-20">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-21" />
      <div className="relative bg-navy-800 border border-navy-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-22">
        <div className="flex items-center justify-between p-6 border-b border-navy-700" data-id="element-23">
          <h2 className="font-playfair text-xl font-bold text-gold-500" data-id="element-24">
            {title}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-navy-700" aria-label="Cerrar" data-id="element-25">
            <XIcon className="w-5 h-5" data-id="element-26" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-[#e0e0e0] text-sm leading-relaxed space-y-4" data-id="element-27">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy-900 py-8 px-4 border-t border-navy-800 text-center" data-id="element-28">
        <div className="max-w-4xl mx-auto" data-id="element-29">
          <p className="text-sm text-gray-500 mb-4" data-id="element-30">
            Este producto no sustituye el consejo médico profesional,
            diagnóstico o tratamiento. Siempre busque el consejo de su médico u
            otro proveedor de salud calificado con cualquier pregunta que pueda
            tener sobre una condición médica.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-31">
            <button onClick={() => setShowPrivacy(true)} className="text-sm text-gray-400 hover:text-gold-500 transition-colors underline underline-offset-2" data-id="element-32">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-33">|</span>
            <button onClick={() => setShowTerms(true)} className="text-sm text-gray-400 hover:text-gold-500 transition-colors underline underline-offset-2" data-id="element-34">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm text-gray-600" data-id="element-35">
            &copy; {new Date().getFullYear()} 40 Rendimiento Alpha. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-36">
        <p className="text-white font-semibold" data-id="element-37">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-38">
          En 40 Rendimiento Alpha, nos comprometemos a proteger tu privacidad.
          Esta política describe cómo recopilamos, usamos y protegemos tu
          información personal.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-39">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-40">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital, incluyendo: nombre, dirección
          de correo electrónico e información de pago. No almacenamos datos de
          tarjetas de crédito en nuestros servidores.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-41">
          2. Uso de la Información
        </h3>
        <p data-id="element-42">
          Tu información se utiliza exclusivamente para: procesar y entregar tu
          compra, enviarte el producto adquirido, comunicarnos contigo sobre tu
          pedido y mejorar nuestros productos y servicios.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-43">
          3. Protección de Datos
        </h3>
        <p data-id="element-44">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-45">
          4. Compartir Información
        </h3>
        <p data-id="element-46">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción son los proveedores de servicios de
          confianza que nos asisten en la operación de nuestro sitio web y el
          procesamiento de pagos, siempre que dichas partes acuerden mantener
          esta información confidencial.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-47">5. Cookies</h3>
        <p data-id="element-48">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto podría afectar algunas funcionalidades del sitio.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-49">6. Tus Derechos</h3>
        <p data-id="element-50">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar la limitación
          del procesamiento de tus datos o ejercer tu derecho a la portabilidad
          de datos.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-51">
        <p className="text-white font-semibold" data-id="element-52">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-53">
          Al acceder y utilizar este sitio web y adquirir nuestros productos,
          aceptas cumplir con los siguientes términos y condiciones.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-54">1. Producto Digital</h3>
        <p data-id="element-55">
          40 Rendimiento Alpha es un producto de información digital en formato
          PDF. Al completar tu compra, recibirás acceso inmediato al material.
          Debido a la naturaleza digital del producto, todas las ventas son
          finales.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-56">2. Uso del Producto</h3>
        <p data-id="element-57">
          El contenido adquirido es para uso personal y no comercial. Queda
          prohibida la reproducción, distribución, modificación o reventa del
          material sin autorización expresa por escrito.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-58">
          3. Descargo de Responsabilidad Médica
        </h3>
        <p data-id="element-59">
          El contenido proporcionado es únicamente con fines informativos y
          educativos. No constituye consejo médico, diagnóstico ni tratamiento.
          Siempre consulta con un profesional de la salud calificado antes de
          realizar cambios en tu dieta, suplementación o rutina de ejercicios.
          Los resultados pueden variar de persona a persona.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-60">4. Resultados</h3>
        <p data-id="element-61">
          Los testimonios y resultados mencionados son experiencias individuales
          y no garantizan resultados específicos. Los resultados dependen de
          múltiples factores incluyendo, pero no limitados a: estado de salud
          actual, adherencia al protocolo, genética y estilo de vida general.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-62">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-63">
          Todo el contenido, incluyendo textos, gráficos, logotipos y material
          descargable, es propiedad de 40 Rendimiento Alpha y está protegido por
          las leyes de propiedad intelectual aplicables.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-64">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-65">
          En ningún caso seremos responsables por daños directos, indirectos,
          incidentales o consecuentes que resulten del uso o la incapacidad de
          usar nuestros productos o servicios.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-66">7. Modificaciones</h3>
        <p data-id="element-67">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en el sitio web.
        </p>
      </Modal>
    </>;
}